module.exports = __webpack_public_path__ + "static/img/award5.1a4da44.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award5.png
// module id = Vnea
// module chunks = 7